<div class="d-flex flex-column order-form-wrapper">
	<div class="form-title mb-4">Create Order</div>

	<div class="row gx-4 gy-3">
		<div class="col-md-6">
			<div class="mb-3">
				<label for="formSelect" class="form-label">Form</label>
				<p-dropdown 
					[filter]="true"
					id="formSelect" 
					[options]="formList$ | async" 
					optionLabel="displayText"
					[(ngModel)]="selectedForm" 
					(onChange)="onFormChange($event.value)" 
					placeholder="Select a form"
					styleClass="form-control">
				</p-dropdown>
			</div>
			<div class="mb-3" *ngIf="isGenericPDFSelected()">
				<label for="productSelect" class="form-label">Product</label>
				<p-dropdown 
					id="productSelect" 
					[filter]="true"
					[options]="productList$ | async" 
					optionLabel="name"
					[filter]="true"
					[(ngModel)]="selectedProduct" 
					(onChange)="onProductChange()" 
					placeholder="Select a product"
					styleClass="form-control">
				</p-dropdown>
			</div>

			<div class="mb-3">
				<label for="orgSelect" class="form-label">Organization</label>
				<p-dropdown 
					id="orgSelect" 
					[options]="organizationList$ | async" 
					optionLabel="name" 
					optionValue="id"
					placeholder="Select an organization" 
					[filter]="true"
					(onFilter)="onOrganizationFilter($event.filter)" 
					[(ngModel)]="createOrderForm.organization"
					styleClass="form-control"></p-dropdown>
			</div>

			<div class="mb-3">
				<label for="referenceId" class="form-label">Reference ID</label>
				<input 
					id="referenceId"
					type="text" 
					class="form-control" 
					pInputText
					[(ngModel)]="createOrderForm.referenceId" 
					name="referenceId"
					(ngModelChange)="validateReferenceId()" />
				<div *ngIf="referenceIdErrorMessage" class="text-danger small">
					{{ referenceIdErrorMessage }}
				</div>
			</div>
		</div>

		<div class="col-md-6">
			<div class="mb-2 h-100">
				<ng-container *ngIf="createOrderForm.form; else noFormSelected">
					<label class="form-label mb-0">
						{{ uploadLabelText }}
					</label>
					<small class="d-block mb-1 note">This is required to create QC Order</small>
		
					<div class="position-relative">
						<cv-drag-and-drop-file 
							*ngIf="displayDragAndDrop" 
							[message]="filesDropMessage"
							(filesDropped)="onFilesDropped($event)" 
							[ngClass]="fileDropped ? 'fileDroped' : ''">
						</cv-drag-and-drop-file>
					</div>
		
					<div *ngIf="mismoFileErrorMessage" class="text-danger text-center small">
						{{ mismoFileErrorMessage }}
					</div>
				</ng-container>
		
				<ng-template #noFormSelected>
					<div class="no-form-selected d-flex justify-content-center align-items-center small fs-5 h-100">
						Select a Form to start
					</div>
				</ng-template>
			</div>
		</div>

	<div class="row">
		<div class="col-md-12 d-flex justify-content-start">
			<cv-engagement-file-upload 
				(fileSelected)="onEngagementFileSelect($event)"
				(fileRemoved)="removeEngagementFile()">
			</cv-engagement-file-upload>
		</div>
	</div>

	<div class="d-flex justify-content-end submit-wrapper">
		<button 
			pButton 
			type="button" 
			label="Create New" 
			class="btn btn-primary" 
			(click)="onSubmit()" 
			[disabled]="!createOrderForm.form ||
        		!createOrderForm.organization ||
        		!createOrderForm.referenceId ||
        		!createOrderForm.file ||
        		mismoFileErrorMessage ||
        		!isEngagementFileValid ||
        		referenceIdErrorMessage || isPDFFormInvalid()">
		</button>
	</div>
</div>